import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#141f14] text-white border-t border-[#233323]">
      <div className="max-w-[109rem] mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        
        {/* Top: Existing Logo centered */}
        <div className="flex justify-center mb-6">
          <Link to="/" className="inline-block group">
            <img
              src="https://assets.auxodev.dk/assets/4a3bbf24-8a93-4bbf-a600-7956f25025f9/imgi-1-pr-logo-1024x369.png"
              alt="PR Entreprise & Anlæg - Autoriseret Kloakmester"
              className="h-24 sm:h-28 lg:h-36 w-auto object-contain bg-white p-3 border border-[#cbd3c5]"
            />
          </Link>
        </div>

        {/* Below Logo: Existing short contact / offer / intro text centered */}
        <div className="max-w-2xl mx-auto text-center mb-8">
          <p className="text-gray-300 text-sm leading-relaxed">
            Professionelt entreprenør- og anlægsarbejde, brolægning samt autoriseret kloakarbejde for private og erhverv i Ishøj, Storkøbenhavn og omegn.
          </p>
        </div>

        {/* Discrete Divider */}
        <div className="border-t border-[#233323] my-8 max-w-4xl mx-auto" />

        {/* Horizontal Row of Contact Information on Desktop (wraps on mobile) */}
        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-8 lg:gap-12 text-sm text-gray-300 mb-10 text-center">
          
          {/* Telefon */}
          <div className="flex items-center gap-2.5">
            <i className="fa-solid fa-phone text-[#9ecc49] shrink-0" aria-hidden="true" />
            <a
              href="tel:22231010"
              className="hover:text-[#9ecc49] transition-colors font-bold text-white whitespace-nowrap"
            >
              Tlf. 22 23 10 10
            </a>
          </div>

          {/* Mail */}
          <div className="flex items-center gap-2.5">
            <i className="fa-regular fa-envelope text-[#9ecc49] shrink-0" aria-hidden="true" />
            <a
              href="mailto:info@prentreprise.dk"
              className="hover:text-[#9ecc49] transition-colors whitespace-nowrap text-white"
            >
              info@prentreprise.dk
            </a>
          </div>

          {/* Adresse */}
          <div className="flex items-center gap-2.5">
            <i className="fa-solid fa-location-dot text-[#9ecc49] shrink-0" aria-hidden="true" />
            <span className="whitespace-nowrap">Ishøj Bygade 90, 2635 Ishøj</span>
          </div>

          {/* CVR */}
          <div className="flex items-center gap-2.5">
            <i className="fa-solid fa-certificate text-[#9ecc49] shrink-0" aria-hidden="true" />
            <span className="font-mono bg-[#0c140c] px-2.5 py-1 border border-[#233323] text-xs text-[#cbd3c5] whitespace-nowrap">
              CVR: 43852507
            </span>
          </div>

        </div>

        {/* Discrete Secondary Navigation Links */}
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs text-gray-400 mb-8 pt-4 border-t border-[#233323]/60">
          <Link to="/" className="hover:text-[#9ecc49] transition-colors">Forside</Link>
          <span>•</span>
          <Link to="/ydelser" className="hover:text-[#9ecc49] transition-colors">Ydelser</Link>
          <span>•</span>
          <Link to="/ydelser/autoriseret-kloakmester" className="hover:text-[#9ecc49] transition-colors">Autoriseret kloakmester</Link>
          <span>•</span>
          <Link to="/om-os" className="hover:text-[#9ecc49] transition-colors">Om os</Link>
          <span>•</span>
          <Link to="/kontakt" className="hover:text-[#9ecc49] transition-colors">Kontakt</Link>
          <span>•</span>
          <a
            href="https://www.iubenda.com/privacy-policy/61026751"
            className="iubenda-white iubenda-noiframe iubenda-embed hover:text-[#9ecc49] transition-colors"
            title="Privatlivspolitik "
          >
            Privatlivspolitik
          </a>
          <span>•</span>
          <a
            href="https://www.iubenda.com/privacy-policy/61026751/cookie-policy"
            className="iubenda-white iubenda-noiframe iubenda-embed hover:text-[#9ecc49] transition-colors"
            title="Cookiepolitik "
          >
            Cookiepolitik
          </a>
        </div>

        {/* Bottom copyright & details */}
        <div className="pt-6 border-t border-[#233323] flex flex-col sm:flex-row items-center justify-between text-xs text-gray-400 gap-4 text-center sm:text-left">
          <p>
            © {currentYear} PR Entreprise & Anlæg ApS • CVR: 43852507. Autoriseret Kloakmester.
          </p>
          <div className="flex items-center space-x-4">
            <span className="text-gray-400">Ishøj • Storkøbenhavn • Sjælland</span>
          </div>
        </div>

      </div>
    </footer>
  );
}
